import { render, staticRenderFns } from "./MortgagesInfo.vue?vue&type=template&id=6ccc5a28&"
import script from "./MortgagesInfo.vue?vue&type=script&lang=ts&"
export * from "./MortgagesInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports